export default "__VITE_ASSET__BX9U_TZ3__"